$(function(){
    $('input.claim_date').datepicker({"changeMonth":true,"changeYear":true});
    $('input.claim_phone').inputmask("+7(999)999-99-99");

    var inp_files = $('.ajax_claim input[type="file"]');
    $('.ajax_claim input[type="file"]').hide();
    inp_files.each(function(ind, el){
        $(el).closest('.field_line').append('<div class="file_box"><span class="file_name">Файл не выбран</span><span class="for_file">Выберите файл</span></div>');
    });
});

$(document).on('click', '.show_form', function(e) {
    e.preventDefault();
    e.stopPropagation();
    var cid = $(this).data('cid');
    claim_form_open(cid);
});

$(document).on('submit', ".ajax_form", function(e){
    e.preventDefault();
    incube_file_ajax('claim', 'json', 'send_form', new FormData($(this)[0]), claimform);
});

$(document).on('change', '.is-invalid', function(){
    $(this).removeClass('is-invalid');
});
    
function claim_form_open(cid){
    var claim_block = $('#' + $(".ajax_claim[data-cid='" + cid + "']").attr('id'));

    claim_block.find('.cf_ok').hide();
    claim_block.find('.form_content').show();
    claim_block.find('.claim_input[type="text"], .claim_input[type="email"]').val('');
    claim_block.find('.claim_input').removeClass('is-invalid');
    claim_block.find('.cf_error').hide();
    claim_block.find('input.claim_phone').inputmask({"mask": "+7 (999) 999-99-99", clearMaskOnLostFocus: false});

    Fancybox.show([{
        src: claim_block,
        type: 'inline'
    }]);
}

function claimform(data){
    var current_claim = $('#ajax_claim_'+data.pid);
    current_claim.find('.cf_error').hide();
    current_claim.find('.cf_ok').hide();

    var current_form = current_claim.find('form');
    var new_rand = getRandomInt(1000000, 10000000);
    current_form[0].rand.value = new_rand;
    if(current_form[0].captcha){
        current_form[0].captcha.value = '';
        current_form.find('.captcha_image').attr('src', '/captcha.php?rand='+new_rand);
    }
    if(data.flag=='ok'){
        current_claim.find('.suc_text').empty();
        current_claim.find('.suc_text').html(data.claim.descr);
        current_claim.find('.cf_ok').show();
        current_claim.find('.form_content').hide();
    }else{
        current_claim.find('.err_text').empty();
        current_claim.find('.captcha_input').removeClass('is-invalid');
        if (data.error[0]) {
            current_claim.find('.claim_input').removeClass('is-invalid');
            for (var key in data.error_fields) {
                $('.claim_input[name="id' + key + '"]').addClass('is-invalid');
            }
            var error_s = '';
            for (var key in data.error) {
                error_s+='<div>'+data.error[key]+'</div>';
            }
            current_claim.find('.err_text').html(error_s);
        }
        if (data.error_captcha) {
            current_claim.find('.captcha_input').addClass('is-invalid');
        }
        current_claim.find('.cf_error').show();
    }  
}

function reload_captcha(pid){
    var rand = Math.random();
    $('#rand-'+pid).val(rand);
    $('#captcha-'+pid).attr('src','/captcha.php?rand='+rand);
}

//Случайное целое.
function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min;
}


//Функционал поля прикрепления файла к форме.
$(document).on('click', '.select_files', function(){
    $(this).parents('.file_input_container').find('input[type="file"]').click();
});
$(document).on('click', '.clear_files', function(){
    var cont = $(this).parents('.file_input_container')
                    .find('input[type="file"]').val(null).trigger('change');
});
$(document).on('change', '.claim_file', function(e){
    var selected_files_text = '';
    var container = $(this).parents('.file_input_container');

    if(this.files.length>0){
        for(var i=0;i<this.files.length;i++){
            if(i>0) selected_files_text += ', ';

            selected_files_text += this.files[i]['name'];
        }
        container.find('.after_select').addClass('show');
        container.find('.select_files').addClass('hide');
    }else{
        selected_files_text = 'Файл не выбран';
        container.find('.after_select').removeClass('show');
        container.find('.select_files').removeClass('hide');
    }
    container.find('.files_names').text(selected_files_text);
});